import { render, staticRenderFns } from "./EspondiloartritesReportPhase.vue?vue&type=template&id=41c97bb9&scoped=true&"
import script from "./EspondiloartritesReportPhase.vue?vue&type=script&lang=js&"
export * from "./EspondiloartritesReportPhase.vue?vue&type=script&lang=js&"
import style0 from "./EspondiloartritesReportPhase.vue?vue&type=style&index=0&id=41c97bb9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c97bb9",
  null
  
)

export default component.exports